import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  clear: both;
  width: 100%;
`;

export const PlusButton = {
  float: 'right',
  margin: '20px',
};

export const Marign20 = {
  margin: '20px',
};
